import axios from "axios";
import urlConfig from "../mixins/url";

class CouvertureService {
    getCouverturesOnShelf() {
        var url = urlConfig.data().url.serverUrl + urlConfig.data().url.Couverture.GetCouverturesOnShelf;
        return axios.get(url);
    }

    mixCouverturesFromShelf(data) {
        var url = urlConfig.data().url.serverUrl + urlConfig.data().url.Couverture.MixCouverturesFromShelf;
        return axios.post(url, data);
    }

    getCouvertureDetailsById(couvertureId) {
        var url = urlConfig.data().url.serverUrl + urlConfig.data().url.Couverture.GetCouvertureInformationsById + couvertureId;
        return axios.get(url);
    }

    getAvailableMeltDownProducts() {
        var url = urlConfig.data().url.serverUrl + urlConfig.data().url.Couverture.GetAvailableMeltDownProducts;
        return axios.get(url);
    }

    changeCouvertureRecipe(couvertureId, recipeId) {
        var url = urlConfig.data().url.serverUrl + urlConfig.data().url.Couverture.ChangeCouvertureRecipe;
        return axios.post(url, {
            couvertureId: couvertureId,
            recipeId: recipeId
        });
    }

}

export default new CouvertureService();
